<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="模块">
            <el-select v-model="deviceInfo.module" filterable clearable placeholder="请选择">
              <el-option v-for="item in selectAllData" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="属性名">
            <el-input v-model="deviceInfo.value" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item> -->
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="模糊搜索"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" :data="lableData" tooltip-effect="dark"
          style="width: 100%;text-align:center" stripe>
          <el-table-column label="序号" type="index" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="module" label="模块">
          </el-table-column>
          <el-table-column prop="value" label="属性名">
          </el-table-column>
          <el-table-column sortable prop="list" label="可选项" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="lx" label="类型" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.lx == '0'" >table</span>
              <span v-else-if="scope.row.lx == '1'" >select</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="updateClick(scope.row)" type="text" size="small">更改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="lableData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!----------------------------------------------------------------- 属性变更修改弹框-------------------------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false" title="属性变更" :before-close="resetting"
      style="width:60% !important;margin-left: 400px;margin-top: 60px;">
      <el-form :model="questionForm" ref="dataForm" label-position="right" label-width="100px" style="width: 90%">
        <el-form-item label="模块">
          <el-input v-model="questionForm.module" :disabled="true" />
        </el-form-item>
        <el-form-item label="字段">
          <el-input v-model="questionForm.lable" :disabled="true" />
        </el-form-item>
        <el-form-item label="属性名">
          <el-input v-model="questionForm.value" />
        </el-form-item>
        <el-form-item v-if="show" label="选择值">
          <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }" :data="listData" tooltip-effect="dark" size="mini"
            style="width: 100%;text-align:center" stripe>
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="valueList" label="属性名">
            </el-table-column>
            <el-table-column label="操作" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <el-button @click="insterClick(scope.row)" type="text" size="small">添加</el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="updateSelectValue(scope.row)" type="text" size="small">更改</el-button>
                <el-button type="text" @click="deleteClick(scope.row)" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" type="success" @click="updataSubmit"
          v-preventReClick>确认</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
      <el-dialog width="30%" title="添加信息" :close-on-click-modal="false"
      :close-on-press-escape="false"  :visible.sync="innerVisible" append-to-body>
        <el-form ref="inform" :model="inform" label-width="80px">
          <el-form-item>
            <el-input v-model="inform.addContent"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addList" v-preventReClick>添加</el-button>
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog width="30%" title="修改信息" :close-on-click-modal="false"
      :close-on-press-escape="false" :visible.sync="innerVisible1" append-to-body>
        <el-form ref="inform" :model="inform" label-width="80px">
          <el-form-item>
            <el-input v-model="inform.updContent"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="updList" v-preventReClick>修改</el-button>
            <el-button @click="innerVisible1 = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
  </div>
</template>
  
<script>
import { findAllModule, deletePersonal, updateModule, selectData } from "../../api/api";
import DeviceComponent from "../../components/common/DeviceComponent.vue";

export default {
  name: "dataDoctionar",
  components: {
    DC: DeviceComponent
  },
  data() {
    return {
      deviceInfo: {
        companyCode: "",
        date: "",
        content: "",
        item: "",
        laboratory: "",
      },
      inform:{},
      show: false,
      innerVisible:false,
      innerVisible1:false,
      listData: [
      ],
      selectAllData: [],
      options: [],
      props1: {
        label: 'companyName',
        value: 'companyCode',
        children: 'zcompany',
        expandTrigger: 'click',
        emitPath: false
      },
      lable: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      lableData: [],
      questionForm: {},
      dialogFormVisible1: false
    };
  },
  mounted() {
    this.findAll();
    this.findAllModule();
  },
  methods: {
    addList(){
      this.listData.push({"valueList":this.inform.addContent})
      this.innerVisible=false
    },
    updList(){
      for(var i=0;i<this.listData.length;i++){
        if(this.listData[i].valueList==this.inform.oldValue){
          this.listData[i].valueList=this.inform.updContent
        }
      }
      this.innerVisible1=false
    },
    findAllModule() {
      selectData().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.selectAllData = data
        }
      });
    },
    resetting(done) {
      this.findAll()
      done()
    },
    insterClick() {
      this.innerVisible=true;
      this.inform={}
    },
    updateSelectValue(row){
      this.innerVisible1=true;
      this.inform={};
      this.inform.oldValue=row.valueList
    },
    updataSubmit() {
      var arr=[];
      for(var i =0;i<this.listData.length;i++){
        arr.push(this.listData[i].valueList)
      }
      this.questionForm.list=arr.toString()
      updateModule(this.questionForm).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message.error(message)
        } else if (status == 200) {
          this.dialogFormVisible1 = false;
          this.findAll();
          this.$message.success("更新成功");
        } else {
          this.$message.error("请求错误")
        }
      });
    },
    //修改弹窗及数据传输
    updateClick(row) {
      this.questionForm =_.cloneDeep(row)
      if (row.lx == 1) {
        this.listData=[]
        var list =  row.list.split(",")
        for(var i = 0;i<list.length;i++){
          this.listData.push({"valueList":list[i]})
        }
        this.show = true
      }
      if (row.lx == 0) {
        this.show = false
        this.listData = []
      }
      this.dialogFormVisible1 = true;
    },
    findAllClick(){
      this.pageIndex=1;
      this.findAll()
    },
    //删除信息
    deleteClick(row) {
      this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row.id
        }
        deletePersonal(params).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message.error(message)
          } else if (status == 200) {
            this.findAll()
            this.$message.success(message)
          } else {
            this.$message.error("请求错误")
          }
        });
      })
    },
    //关闭窗口
    cancel() {
      this.dialogFormVisible1 = false;
      this.findAll();
    },
    //选择资产
    transferValue(outData) {
      this.questionForm = outData;
    },
    //查找字段信息
    findAll() {
      var map = {
        module: this.deviceInfo.module,
        value: this.deviceInfo.value,
        content: this.deviceInfo.content
      }
      findAllModule(map).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null){
            this.data = []
          } else {
            this.data = data;
          }
          this.lableData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
        } 
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.lableData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.lableData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.el-input {
  width: 100%
}

.btn {
  float: left;
  margin-left: 5px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/SystemSettings/dataDictionary.vue